import React, { useState, useRef, useMemo } from 'react';
import { Modal, Button, Carousel } from 'antd';
import { getIn18Text } from 'api';
import './index.scss';
import SlideItem, { DefaultItemHeight } from './SlideItem';
import SlideList from './SlideList';
import cn from 'classnames';
const GuideCarousel = props => {
    var _a;
    const [carouselSelected, setCarouselSelected] = useState(0);
    const carouselRef = useRef(null);
    const CAROUSEL_CONTENTS = ((_a = props.config) === null || _a === void 0 ? void 0 : _a.list) || [];
    const heights = useMemo(() => CAROUSEL_CONTENTS.map(item => { var _a; return (_a = item.itemHeight) !== null && _a !== void 0 ? _a : DefaultItemHeight; }), []);
    const onClose = (type) => {
        props.onClose(type);
    };
    const onSlideSelect = (index) => {
        if (carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) {
            carouselRef.current.goTo(index);
        }
    };
    const onCarouselSlide = (_from, to) => {
        setCarouselSelected(to);
    };
    if (!props.config) {
        return null;
    }
    return (React.createElement(Modal, { maskStyle: { zIndex: 9999, left: 0 }, wrapClassName: "new-guide-for-aside-wrapper-mask", className: cn('new-guide-for-aside-wrapper', props.className), visible: true, footer: null, width: '910px', centered: true, maskClosable: false, bodyStyle: { padding: 0 }, onCancel: () => onClose('cancel') },
        React.createElement("div", { className: "new-guide-for-aside" },
            React.createElement("div", { className: "new-guide-for-aside-left" },
                React.createElement("div", { className: "ng-header" },
                    React.createElement("div", { className: "ng-title" },
                        React.createElement("span", { className: "ng-title-text" }, props.config.title),
                        props.config.label ? React.createElement("span", { className: "ng-title-label" }, props.config.label) : React.createElement(React.Fragment, null)),
                    props.config.intro ? React.createElement("div", { className: "ng-intro" }, props.config.intro) : null),
                React.createElement("div", { className: "ng-slide-container" },
                    React.createElement(SlideList, { heights: heights, onSelect: onSlideSelect, trigger: "hover", selected: carouselSelected }, CAROUSEL_CONTENTS.map(v => (React.createElement(SlideItem, Object.assign({}, v)))))),
                React.createElement("div", { className: "ng-btn-footer" },
                    React.createElement(Button, { type: "primary", onClick: onClose, className: "ng-confirm-btn" }, getIn18Text('LIJITIYAN')))),
            React.createElement("div", { className: "new-guide-for-aside-right" },
                React.createElement(Carousel, { ref: carouselRef, dots: { className: 'new-guide-carousel-dots' }, beforeChange: onCarouselSlide, speed: 320 }, CAROUSEL_CONTENTS.map(v => (React.createElement("div", { className: "new-guide-carousel-img-container", key: v.key },
                    React.createElement("img", { className: "new-guide-carousel-img", src: v.image, alt: "" })))))))));
};
export default GuideCarousel;
